export enum InstructionType {
	Move1,
	Move2,
	Move3,
	BackUp,
	TurnLeft,
	TurnRight,
	UTurn,
	Halt,
}

export type InstructionCounts = Map<InstructionType, number>;

export const INSTRUCTIONS_ORDER = [
	InstructionType.Move1,
	InstructionType.Move2,
	InstructionType.Move3,
	InstructionType.BackUp,
	InstructionType.TurnLeft,
	InstructionType.TurnRight,
	InstructionType.UTurn,
	InstructionType.Halt,
];

export function getInstructionType(name: string): InstructionType {
	switch (name) {
		case 'Move1':
			return InstructionType.Move1;
		case 'Move2':
			return InstructionType.Move2;
		case 'Move3':
			return InstructionType.Move3;
		case 'BackUp':
			return InstructionType.BackUp;
		case 'TurnLeft':
			return InstructionType.TurnLeft;
		case 'TurnRight':
			return InstructionType.TurnRight;
		case 'UTurn':
			return InstructionType.UTurn;
		case 'Halt':
			return InstructionType.Halt;
		default:
			throw new Error('Invalid InstructionType');
	}
}
